import { type MultiActionQuery } from '#shared/api/schema';
import { showError, showSuccess } from '#shared/lib/toast';
import { setVariantsRequiresMarking } from '../api';

type Options = {
    successText: string;
};

export async function setProductVariantsRequiresMarking(
    query: MultiActionQuery,
    requiresMarking: boolean,
    { successText }: Options
) {
    try {
        await setVariantsRequiresMarking({
            query,
            requires_marking: requiresMarking,
        });

        showSuccess(successText);
    } catch (error) {
        showError({ label: 'Не удалось изменить настройки маркировки' }, error);
    }
}
